<div class="modal fade" id="updateConsumptionModal" tabindex="-1" role="dialog" aria-labelledby="updateConsumption" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        @if (iStudent) {
          <h3 class="modal-title" id="newArticleTitle" name="startAt">
            MODIFIER LA CONSOMMATION #{{iConsumption?.id}} - {{iStudent.lastname}} {{iStudent.firstname}}
          </h3>
        }
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      @if (popupError && popupError.length > 0) {
        <div id="newArticleError" class="alert alert-danger mt-4 ms-4 me-4" role="alert">
          {{popupError}}
        </div>
      }

      <form [formGroup]="consumptionForm" #f2="ngForm" name="newEventForm" (ngSubmit)="f2.form.valid && onUpdateeConsumption()" novalidate>
        <div>
          <div class="form-row ms-4 p-1 mt-4">
            <div class="input-group raw mb-3">
              <div class="col-4">
                <label for="article-date-u" class="col-form-label">CHOISIR LA DATE</label>
                <input id="article-date-u" type="date" class="form-control form-control-lg form-control-borderless"
                  name="date" formControlName="date" required aria-describedby="basic-addon2">
                @if (consumptionSubmited && f2.form.controls.date.status == 'INVALID') {
                  <p class="alert alert-danger p-0" role="alert">
                    Merci de définir la date !
                  </p>
                }
              </div>
              <div class="col-6">
                <label for="editConsumption-article" class="col-form-label">CHOISIR UN ARTICLE</label>
                <select id="editConsumption-article" class="form-control form-control-lg form-control-borderless" formControlName="articleId"> <!--(change)="selectMonitor($event)" -->
                  <option [ngValue]="null" disabled>Choisir un artcile</option>
                  @for (a of iArticles; track a) {
                    <option [ngValue]="a.id" >{{a.name}} - {{a.price}} €</option>
                  }
                </select>
                @if (consumptionSubmited && f2.form.controls.articleId.status == 'INVALID') {
                  <p class="alert alert-danger p-0" role="alert">
                    Merci de choisir un article !
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="form-row ms-4 p-1 mt-1">
            <div class="input-group raw mb-3">
              <div class="col-4">
                <label for="quantity" class="col-form-label">QUANTITE</label>
                <input id="quantity" class="form-control form-control-lg form-control-borderless"
                  name="quantity" formControlName="quantity" required aria-describedby="basic-addon2">
                @if (consumptionSubmited && f2.form.controls.quantity.status == 'INVALID') {
                  <p class="alert alert-danger p-0" role="alert">
                    Merci de définir la quantité d'article !
                  </p>
                }
              </div>
              <div class="col-6">
                <label for="consumption-description-u" class="col-form-label">DESCRIPTION</label>
                <textarea class="form-control" id="consumption-description-u" name="description" formControlName="description"  rows="3"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ANNULER</button>
          <button type="button" class="btn btn-primary" type="submit" (click)="isConsumptionSubmited(f2.form)">VALIDER</button>
        </div>
      </form>
    </div>
  </div>
</div>
